export default {
    user: null,
    userAdmin:null,    
    isLogged: false, 
    myContracts: null, 
    benefits: [],
    emailReset: null, 
    messageEmailReset: '',
    showModules: null
}